<template>
  <div class="mx-10 ma-5">
    <v-card class="pa-5">
      <v-row>
        <v-col cols="12" md="3">
          <v-select
            v-model="filters.branch_id"
            :items="branches"
            item-text="name"
            item-value="id"
            label="Branch"
            clearable
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-select
            v-model="filters.customer_id"
            :items="customers"
            item-text="company_name"
            item-value="id"
            label="Customer"
            clearable
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-btn color="primary" @click="fetchReport" :loading="loading"
            >Generate</v-btn
          >
        </v-col>
        <v-col cols="12" md="2">
          <v-btn
            color="success"
            @click="downloadPDF"
            :disabled="!reportData.length"
          >
            Download PDF
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="reportData"
        :loading="loading"
        class="mt-5"
      />
      <v-alert
        v-if="!loading && reportData.length === 0"
        type="info"
        class="mt-5"
        outlined
      >
        No due customers found.
      </v-alert>
    </v-card>
  </div>
</template>

<script>
import { ReportService } from "@/services/report-service.js";
import { CustomerService } from "@/services/customer-service.js";
import { BranchService } from "@/services/branch-service.js";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  name: "DueCustomerReport",
  data() {
    return {
      filters: {
        branch_id: null,
        customer_id: null,
      },
      branches: [],
      customers: [],
      reportData: [],
      loading: false,
      headers: [
        { text: "Invoice Number", value: "invoice_number" },
        { text: "Invoice Date", value: "invoice_date" },
        { text: "Customer Name", value: "customer_name" },
        { text: "Total Invoice", value: "total_invoice" },
        { text: "Paid Amount", value: "paid_amount" },
        { text: "Due Amount", value: "due_amount" },
      ],
    };
  },
  watch: {
    "filters.branch_id"(val, oldVal) {
      if (val !== oldVal) this.fetchReport();
    },
    "filters.customer_id"(val, oldVal) {
      if (val !== oldVal) this.fetchReport();
    },
  },
  created() {
    this.fetchBranches();
    this.fetchCustomers();
    this.fetchReport();
  },
  methods: {
    async fetchBranches() {
      try {
        const res = await BranchService.getAll();
        this.branches = res.data.data || [];
      } catch {
        this.branches = [];
      }
    },
    async fetchCustomers() {
      try {
        const res = await CustomerService.getAll();
        this.customers = res.data.data || [];
      } catch {
        this.customers = [];
      }
    },
    async fetchReport() {
      this.loading = true;
      try {
        const res = await ReportService.getDueCustomerReport(this.filters);
        this.reportData = res.data.data || [];
      } catch {
        this.reportData = [];
      } finally {
        this.loading = false;
      }
    },
    downloadPDF() {
      const doc = new jsPDF();

      // Main heading: larger and bold
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");
      doc.text("Due Customer Report", 14, 15);

      // Reset font for filters
      doc.setFontSize(11);
      doc.setFont("helvetica", "normal");

      // Prepare filter summary, each on its own line
      let y = 22;
      const branch = this.branches.find(
        (b) => String(b.id) === String(this.filters.branch_id)
      );
      const customer = this.customers.find(
        (c) => String(c.id) === String(this.filters.customer_id)
      );
      if (branch) {
        doc.text(`Branch: ${branch.name}`, 14, y);
        y += 7;
      }
      if (customer) {
        doc.text(`Customer: ${customer.company_name}`, 14, y);
        y += 7;
      }

      // Add a little space before the table
      if (branch || customer) {
        y += 2;
      }

      doc.autoTable({
        head: [this.headers.map((h) => h.text)],
        body: this.reportData.map((row) => [
          row.invoice_number,
          row.invoice_date,
          row.customer_name,
          row.total_invoice,
          row.paid_amount,
          row.due_amount,
        ]),
        startY: y,
      });

      doc.save("due_customer_report.pdf");
    },
  },
};
</script>
